export enum TimeRecordErrorMessage {
  OverTime = '인류는 하루를 24시간으로 정했습니다.',
}

export enum TimeRecordSocketEventName {
  Upsert = 'upsert',
}
